<template>
  <section class="planos" ref="sectionRef" :class="{ fixo: mostrarFixo }">
    <div class="titulo">
      <h2>Reative sua assinatura</h2>
      <p>Volte suas áreas de membros para o ar assinando os planos Level:</p>
    </div>
    <!-- Itens -->
    <div class="itens">
      <div v-for="(plano, index) in planos" class="item" :key="index" :class="{ destaque: plano.class === storePerfil.usuario?.assinatura?.tipo }">
        <div class="nome">
          <img :src="plano.simbolo" class="simbolo" />
          <h3>{{ plano.nome }}</h3>
        </div>
        <div class="preco">
          <div class="valor">
            <h2>{{ plano.precos.valor }}</h2>
            <div class="parte">
              <h4>{{ plano.precos.texto }}</h4>
              <h6>{{ plano.precos.detalhe }}</h6>
            </div>
          </div>
          <h5>
            {{ plano.precos.cheio }}
            <span>{{ plano.precos.desconto }}</span>
          </h5>
          <div class="pix" v-if="plano.precos.pix">
            <Svgs nome="pix" />
            <p>{{ plano.precos.pix }}</p>
          </div>
          <div class="pix dois" v-if="!plano.precos.pix">
            <Svgs nome="cadeado" />
            <p>Publicação Bloqueada</p>
          </div>
        </div>
        <div class="beneficios">
          <div class="beneficio" :class="{ bloqueado: !item.liberado }" v-for="item in plano.beneficios">
            <div class="icone">
              <Svgs :nome="item.icon" />
            </div>
            <p>{{ item.titulo }}</p>
          </div>
        </div>
        <div class="botao">
          <a :href="plano.botao.linkBotao" :class="{ desativado: !plano.botao.linkBotao }" target="_blank">
            <p>{{ plano.class === storePerfil.usuario?.assinatura?.tipo ? 'Seu plano atual' : plano.botao.texto }}</p>
          </a>
        </div>
      </div>
    </div>
    <SectionComparar />
    <SectionContato />
  </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted, reactive } from 'vue'
import { useStorePerfil } from '@stores'
import SectionComparar from '@components/app/reativar/partials/SectionComparar.vue'
import SectionContato from '@components/app/reativar/partials/SectionContato.vue'
import Svgs from '@svgs'

const sectionRef = ref(null)
const mostrarFixo = ref(false)
const storePerfil = useStorePerfil()

const planos = reactive([
  // Free
  {
    class: 'free',
    simbolo: 'https://central-statics.nyc3.digitaloceanspaces.com/global/planos/free.png',
    nome: 'Plano Free',
    destaque: false,
    precos: {
      valor: 'R$ 0',
      texto: '/ mês',
      cheio: 'Indicado para testes e estudos',
      pix: '',
      desconto: ''
    },
    beneficios: [
      { icon: 'cursor', liberado: true, titulo: '1 área de membros' },
      { icon: 'dominio', liberado: true, titulo: 'Sem domínio ou publicação' },
      { icon: 'check', liberado: true, titulo: 'Crie de graça' }
    ],
    botao: {
      linkBotao: '',
      texto: 'Plano Padrão'
    }
  },
  // Silver
  {
    class: 'silver',
    simbolo: 'https://central-statics.nyc3.digitaloceanspaces.com/global/planos/silver.png',
    nome: 'Plano Silver',
    destaque: false,
    precos: {
      valor: 'R$ 118',
      texto: '/ mês',
      cheio: 'ou R$ 1.147 à vista',
      pix: 'R$ 997 no PIX',
      desconto: 'Acesso Anual'
    },
    beneficios: [
      { icon: 'cursor', liberado: true, titulo: '1 área de membros' },
      { icon: 'usuarios', liberado: true, titulo: '4.000 alunos' },
      { icon: 'infinito', liberado: true, titulo: 'Cursos, aulas e módulos ilimitados' }
    ],
    botao: {
      linkBotao: 'https://payment-link-v3.pagar.me/pl_Qg5AP6Ky3xJl45XuzC2w1bRjwd2NO9GW',
      texto: 'Assinar Silver'
    }
  },
  // Gold
  {
    class: 'gold',
    simbolo: 'https://central-statics.nyc3.digitaloceanspaces.com/global/planos/gold.png',
    nome: 'Plano Gold',
    destaque: true,
    precos: {
      valor: 'R$ 345',
      texto: '/ mês',
      cheio: 'ou R$ 3.347 à vista',
      pix: 'R$ 2.997 no PIX',
      desconto: 'Acesso Anual'
    },
    beneficios: [
      { icon: 'cursor', liberado: true, titulo: '3 áreas de membros' },
      { icon: 'usuarios', liberado: true, titulo: '15.000 alunos' },
      { icon: 'infinito', liberado: true, titulo: 'Cursos, aulas e módulos ilimitados' }
    ],
    botao: {
      linkBotao: 'https://payment-link-v3.pagar.me/pl_oGMKq9Y1Q7yPJmRMtNhjL4OZdr0EVNg2',
      texto: 'Assinar Gold'
    }
  },
  // Diamond
  {
    class: 'diamond',
    simbolo: 'https://central-statics.nyc3.digitaloceanspaces.com/global/planos/diamond.png',
    nome: 'Plano Diamond',
    destaque: false,
    precos: {
      valor: 'R$ 702',
      texto: '/ mês',
      cheio: 'ou R$ 6.797 à vista',
      pix: 'R$ 5.997 no PIX',
      desconto: 'Acesso Anual'
    },
    beneficios: [
      { icon: 'cursor', liberado: true, titulo: '10 áreas de membros' },
      { icon: 'usuarios', liberado: true, titulo: '100.000 alunos' },
      { icon: 'infinito', liberado: true, titulo: 'Cursos, aulas e módulos ilimitados' }
    ],
    botao: {
      linkBotao: 'https://payment-link-v3.pagar.me/pl_5wvR2DXdalzA0yqJhLUl0Nm6rGJ7YW4L',
      texto: 'Assinar Diamond'
    }
  }
])

const verScroll = () => {
  if (!sectionRef.value) return
  mostrarFixo.value = sectionRef.value.scrollTop > 500
}

onMounted(() => {
  if (!sectionRef.value) return
  sectionRef.value.addEventListener('scroll', verScroll)
})

onUnmounted(() => {
  if (!sectionRef.value) return
  sectionRef.value.removeEventListener('scroll', verScroll)
})
</script>

<style scoped>
section.planos {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 40px 20px 20px 20px;
  width: 100%;
  height: calc(100dvh - 80px);
  max-height: calc(100dvh - 80px);
  overflow-y: scroll;
}
.titulo {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  padding: 0 0 40px 0;
}
.titulo h2 {
  font-family: var(--bold);
  font-size: var(--f4);
  color: var(--cor-branco);
}
.titulo p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
  margin: 10px 0 0 0;
}
/* Itens */
.itens {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.itens .item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: calc(25% - 10px);
  background-color: var(--cor-escuro-2);
  border: 2px solid var(--cor-escuro-2);
  border-radius: 10px;
  position: relative;
}
.itens .item.destaque {
  background-color: var(--cor-escuro-1);
  border: 2px solid var(--cor-marca);
}
.itens .item .nome {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 30px 0 0 0;
}
.itens .item .nome img {
  width: 40px;
  min-width: 40px;
  position: absolute;
  top: -20px;
  transition: all 0.3s;
}
.itens .item:hover .nome img {
  transform: scale(1.05);
}
.itens .item .nome h3 {
  font-family: var(--medium);
  font-size: var(--f2);
  color: var(--cor-branco);
}
/* Preço */
.itens .item .preco {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
}
.itens .item .preco .valor {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 15px 0 0 0;
}
.itens .item .preco h2 {
  font-family: var(--bold);
  font-size: var(--f4);
  color: var(--cor-branco);
  margin: 0 5px 0 0;
}
.itens .item .preco h4 {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-branco);
}
.itens .item .preco h5 {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-branco);
  line-height: 1.5;
  margin: 10px 0 0 0;
}
.itens .item .preco h5 span {
  font-family: var(--bold);
  color: var(--cor-azul);
}
.itens .item .preco .parte:nth-child(1) {
  align-items: flex-end;
  text-align: right;
}
.itens .item .preco .parte {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.itens .item .preco .pix {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #4db6ac39;
  padding: 5px 10px;
  border-radius: 50px;
  margin: 10px 0 0 0;
}
.itens .item .preco .pix.dois {
  background-color: #df861f39;
}
.itens .item .preco .pix.dois svg {
  fill: var(--cor-laranja);
}
.itens .item .preco .pix.dois p {
  color: var(--cor-laranja);
}
.itens .item .preco .pix svg {
  width: 15px;
  min-width: 15px;
  max-height: 15px;
  fill: #4db6ac;
  margin: 0 5px 0 0;
}
.itens .item .preco .pix p {
  font-family: var(--bold);
  font-size: var(--f2);
  color: #4db6ac;
}
/* Botão */
.itens .item .botao {
  width: 100%;
  padding: 0 15px 15px 15px;
}
.itens .item .botao a {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--cor-marca);
  padding: 12px 20px;
  border-radius: 8px;
  width: 100%;
  transition: all 0.3s;
}
.itens .item .botao a.desativado {
  background-color: var(--cor-escuro-3);
  pointer-events: none;
}
.itens .item .botao a:hover {
  background-color: var(--cor-marca-escuro);
}
.itens .item .botao a p {
  font-family: var(--medium);
  font-size: var(--f2);
  color: var(--cor-branco);
  text-transform: capitalize;
}
.itens .item .botao a img {
  width: 100%;
  max-width: 15px;
  margin: 0 10px 0 0;
}
/* Benefícios */
.beneficios {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 15px 15px 0 15px;
}
.beneficios .beneficio {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  margin: 0 0 15px 0;
}
.beneficios .beneficio p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-escuro-6);
}
.beneficios .beneficio svg {
  width: 12px;
  min-width: 12px;
  max-height: 12px;
  fill: var(--cor-escuro-6);
  margin: 0 10px 0 0;
}
/*
Responsivo
*/
@media screen and (max-width: 1024px) {
  section.planos {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 90px 0 20px 0;
    width: 100%;
    height: auto;
    max-height: auto;
    overflow-y: inherit;
  }
  .titulo {
    padding: 0 20px;
  }
  .titulo h2 {
    font-family: var(--bold);
    font-size: var(--f3);
    color: var(--cor-branco);
  }
  .titulo p {
    font-size: var(--f2);
    line-height: 1.5;
    width: 100%;
    max-width: 250px;
  }
  /* Itens */
  .itens {
    flex-direction: column;
    width: 100%;
    padding: 40px 20px 0 20px;
  }
  .itens .item {
    width: 100%;
    min-width: 100%;
    margin: 0 0 30px 0;
  }
}
</style>
